import { createContext, useContext } from "react";

/**
 * Só administradores podem excluir registros (regra do Portal). O valor vem do
 * /api/me e vale para toda a árvore: cada botão de excluir consulta o hook e
 * SOME quando é falso (esconder, não desabilitar). O servidor decide de novo em
 * requireExcluir — aqui é só para não oferecer o que a pessoa não pode fazer.
 */
const Ctx = createContext(false);
export const PermissoesProvider = Ctx.Provider;
export const usePodeExcluir = () => useContext(Ctx);
